import { useMemo, useState } from 'react';

const useImpersonate = () => {
  const [impersonatingAccountId, setimpersonatingAccountId] = useState<
    number | null
  >(
    localStorage.getItem('impersonatingAccountId')
      ? parseInt(localStorage.getItem('impersonatingAccountId') as string, 10)
      : null
  );
  const [companyName, setCompanyName] = useState<string | null>(
    localStorage.getItem('companyName')
      ? localStorage.getItem('companyName')
      : null
  );
  const [companyChatbotEnabled, setCompanyChatbotEnabled] = useState<
    boolean | null
  >(
    localStorage.getItem('companyChatbotEnabled')
      ? (JSON.parse(
          localStorage.getItem('companyChatbotEnabled') as string
        ) as boolean)
      : null
  );
  const value = useMemo(
    () => ({
      impersonatingAccountId,
      setimpersonatingAccountId,
      companyName,
      setCompanyName,
      companyChatbotEnabled,
      setCompanyChatbotEnabled,
      impersonate: (id: number, name: string) => {
        localStorage.setItem('impersonatingAccountId', id.toString());
        localStorage.setItem('companyName', name);
        setimpersonatingAccountId(id);
        setCompanyName(name);
        localStorage.setItem('companyChatbotEnabled', false.toString());
        setCompanyChatbotEnabled(false);
      },
      clearImpersonationSession: () => {
        localStorage.removeItem('impersonatingAccountId');
        localStorage.removeItem('companyName');
        setimpersonatingAccountId(null);
        setCompanyName(null);
        setCompanyChatbotEnabled(null);
      },
    }),
    [impersonatingAccountId, companyName, companyChatbotEnabled]
  );
  return value;
};
export default useImpersonate;
